// extracted by extract-css-chunks-webpack-plugin
module.exports = {"separator":"css-WY0EoHSmC1"};